// src/contexts/UserContext.js
import React, { createContext, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
// const API_URL = "http://125.63.103.94:90";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState({
    Username: "NA",
    RoleName: "NA",
    RoleId: "",
    ClientName: "",
    ClientId: "",
    CompCode: "",
  });
  const Navigate = useNavigate();
  const changeClient = (compCode, clientCode, clientName) => {
    setUser((prev) => ({
      ...prev,
      ClientName: clientName,
      ClientId: clientCode,
      CompCode: compCode,
    }));
  };
  const login = async ({ username, password }) => {
    try {
      //console.log(API_URL);
      const response = await fetch(
        `${API_URL}/facility/login/${username}/${password}`
      ).then((res) => res.json());

      // if (!response.ok) {
      //   throw new Error(`HTTP error! status: ${response.status}`); // Throw an error on a bad status
      // }
      // console.log(response);
      if (response.success) {
        setUser({
          UserName: response.data[0].Username,
          RoleName: response.data[0].RoleName,
          RoleId: response.data[0].fk_RoleId, // 4 for viewer
          ClientName: response.data[0].ClientDashName,
          ClientId: response.data[0].fk_ClientCode,
          CompCode: response.data[0].CompCode,
        });

        setIsAuthenticated(true);
        if (response.data[0].fk_RoleId == 3) {
          Navigate("/detail");
          return;
        }
        console.log(response.data[0].fk_RoleId);
        Navigate("/dashboard");
      } else {
        window.alert("Invalid Cred!");
      }
    } catch (error) {
      console.error("Failed to login:", error);
    }
  };

  const logout = async () => {
    try {
      //console.log("Logging out..");
      // const response = await fetch("http://localhost:2000/api/logout", {
      //   method: "GET",
      //   credentials: "include",
      // });

      // const userInfo = await response.json();
      // console.log("res", userInfo);
      // if (userInfo.success) {
      //   console.log("Logout Info", userInfo);
      //   setUser(null); // Assuming setUser is a state setter from useState
      //   Navigate("/login"); // Correct way to programmatically navigate
      // }
      window.location.reload();
    } catch (error) {
      console.error("Failed to logout:", error); // Log the error or handle it in another way
    }
  };

  const userDetail = async () => {
    try {
      //console.log("getting user details...");
      const response = await fetch("http://localhost:2000/api/user_detail", {
        method: "GET",
        credentials: "include", // Ensure cookies are included with the request
      });

      const userInfo = await response.json();
      console.log("res", userInfo);
      if (userInfo.success) {
        console.log("Logout Info", userInfo);
        setUser(null); // Assuming setUser is a state setter from useState
        Navigate("/login"); // Correct way to programmatically navigate
      }
    } catch (error) {
      console.error("Failed to logout:", error); // Log the error or handle it in another way
    }
  };
  return (
    <UserContext.Provider
      value={{ user, login, logout, isAuthenticated, changeClient }}
    >
      {children}
    </UserContext.Provider>
  );
};

// Custom hook to use the user context
export const useUser = () => useContext(UserContext);
